import { useField } from 'formik';
import { FC } from 'react';

import type { InputTextProps } from '@types';
import { cn } from '@utils';

import { BaseTextInput } from '.';

export const FilledTextInput: FC<InputTextProps> = ({ name, className, inputMod, ...props }) => {
  const [field] = useField(name);

  return (
    <BaseTextInput
      {...props}
      name={name}
      inputMod={inputMod}
      className={cn(
        'w-full h-11 peer outline-none px-4 py-3 transition-all duration-300 focus:ring-2',
        field.value && 'pt-9 pb-4 placeholder-transparent',
        (!field.value || field.value === '') &&
          'group-focus-within:pt-9 peer-valid:pt-9 peer-valid:pb-4 group-focus-within:pb-4 group-focus-within:placeholder-gray-400 placeholder-transparent',
        className,
      )}
    />
  );
};
